export default __webpack_public_path__ + "static/media/ResourceSink.256.cb363468.png";